<template>
  <div class="container z-grid v-page-section-container-padding">
    <div class="col-span-full xl:col-start-2 xl:col-end-12 2xl:col-start-3 2xl:col-end-11" :class="{ 'lg:col-start-2 lg:col-end-12': type === 'discovery' }">
      <MoleculeCardBanner
        :title="title"
        :top-label="topLabel"
        :sub-label="subLabel"
        :icon="icon"
        :image="image"
        :button-title="buttonTitle"
        :button-url="buttonUrl"
        :theme="theme"
        :is-questionnaire-promo="isQuestionnairePromo"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
  topLabel: { type: String, required: false, default: undefined },
  subLabel: { type: String, required: false, default: undefined },
  icon: { type: String, required: false, default: undefined },
  image: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  buttonTitle: { type: String, required: true },
  buttonUrl: { type: String, required: true },
  theme: { type: String, required: true },
  type: { type: String, required: false, default: undefined },
  isQuestionnairePromo: { type: Boolean, required: false, default: false },
})
</script>
